import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/toPromise";
import { Meta, Title } from "@angular/platform-browser";
@Injectable()
export class Globals {
  public BASE_API_URL = "https://xosotravinh.vn/";
  public BASE_API_URL_XOSOTUCHON = "https://vstc.xosotravinh.vn/";
  //public USERS: any = {};
  public description: any;
  public PERMISSION: any;
  public title: any = {};
  public configCkeditor = {
    filebrowserBrowseUrl: this.BASE_API_URL + "public/ckfinder/ckfinder.html",
    filebrowserImageBrowseUrl:
      this.BASE_API_URL + "public/ckfinder/ckfinder.html?type=Images",
    filebrowserFlashBrowseUrl:
      this.BASE_API_URL + "public/ckfinder/ckfinder.html?type=Flash",
    filebrowserUploadUrl:
      this.BASE_API_URL +
      "public/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files",
    filebrowserImageUploadUrl:
      this.BASE_API_URL +
      "public/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Images",
    filebrowserFlashUploadUrl:
      this.BASE_API_URL +
      "public/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Flash",
    contentsCss: ["/assets/ckeditor/contents.css"],
  };
  // public configCkeditor = {
  // 	filebrowserBrowseUrl: this.BASE_API_URL + 'public/ckfinder/ckfinder.html',
  // 	filebrowserImageBrowseUrl: this.BASE_API_URL + 'public/ckfinder/ckfinder.html?type=Images',
  // 	filebrowserUploadUrl:
  // 		this.BASE_API_URL + 'public/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Files',
  // 	filebrowserImageUploadUrl:
  // 		this.BASE_API_URL + 'public/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Images',
  // };
  constructor(
    public http: Http,
    public _title: Title,

    public _meta: Meta
  ) {
    this.getTitle();
  }
  public checkLogin(): Observable<boolean> {
    return this.http
      .post(this.BASE_API_URL + "api/checklogin", this.USERS.get())
      .map((res) => res.json());
  }
  public getTitle() {
    if (
      window["title"] &&
      typeof window["title"] === "object" &&
      Object.keys(window["title"]).length > 0
    ) {
      this.title = window["title"];
    } else {
      this.http
        .get(this.BASE_API_URL + "api/title")
        .map((response: Response) => response.json())
        .subscribe((response) => {
          let data = response["data"];
          data.keywords =
            data.keywords && data.keywords.length > 2
              ? typeof data.keywords === "object"
                ? data.keywords
                : JSON.parse(data.keywords)
              : [];
          data.keywords.toString();
          this.title = data;
          this.description = data.description;
          window["title"] = data;
          let shortcut = document.querySelector("[type='image/x-icon']");
          if (shortcut) {
            shortcut.setAttribute("href", data.shortcut);
          }
          this.seo(data);
        });
    }
  }
  public callTitle() {
    if (this.title && Object.keys(this.title).length > 0) {
      return this.title;
    } else {
      this.getTitle();
    }
  }
  public seo = (option) => {
    if (option.title || option.name) {
      this._title.setTitle(option.name ? option.name : option.title);
    }
    if (option.description) {
      this._meta.addTag({ name: "description", content: option.description });
    }
    if (option.keywords) {
      this._meta.addTag({
        name: "keywords",
        content: option.keywords.toString(),
      });
    }
  };
  public USERS = {
    token: "users",
    get: () => {
      return window.localStorage.getItem(this.USERS.token)
        ? JSON.parse(window.localStorage.getItem(this.USERS.token))
        : {};
    },
    set: (data) => {
      window.localStorage.setItem(this.USERS.token, JSON.stringify(data));
    },
    check: () => {
      return window.localStorage.getItem(this.USERS.token) ? 1 : 0;
    },
    remove: () => {
      this.http.get(this.BASE_API_URL + "api/logout").map((res) => res.json());
      window.localStorage.removeItem(this.USERS.token);
      window.location.assign(this.BASE_API_URL);
    },
  };
  public CUSTOMER = {
    token: "customer",
    get: () => {
      return window.localStorage.getItem(this.CUSTOMER.token)
        ? JSON.parse(window.localStorage.getItem(this.CUSTOMER.token))
        : {};
    },
    set: (data) => {
      window.localStorage.setItem(this.CUSTOMER.token, JSON.stringify(data));
    },
    remove: () => {
      window.localStorage.removeItem(this.CUSTOMER.token);
    },
    key: (k) => {
      let data = this.CUSTOMER.get();
      return data[k] ? data[k] : "";
    },
    check: () => {
      return window.localStorage.getItem(this.CUSTOMER.token) ? 1 : 0;
    },
  };
}



// WEBPACK FOOTER //
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/globals.ts